import type { ReportsResponse } from '@pulse/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** The weekly status report for a week; the latest when `week` is null (WR-2). */
export function useReport(week: string | null) {
  return useQuery({
    queryKey: ['reports', week ?? 'latest'],
    queryFn: () => apiRequest<ReportsResponse>('/api/reports', { searchParams: { week: week ?? undefined } }),
    staleTime: 60_000,
  });
}
